import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import { useState } from 'react';
import Grow from '@mui/material/Grow';
import Autocomplete from '@Components/MuiWrappers/Autocomplete';

const QuickFind = (props) => {

    const currentSite = useRecoilValue(atoms.currentWebsite);
    const [isFocused, setIsFocused] = useState(false);
    const [activeSearch, setActiveSearch] = useState('Equipment');
    const searchTabs = props.searchTypes;

    const setFocus = (e, key) => {
        e.preventDefault();
        setActiveSearch(key);
        setIsFocused(true);
    }

    return (
        <div
            id={props.id}
            className='quick-find'
            onFocus={() => setIsFocused(true)}
            onBlur={e => e.relatedTarget === null && setIsFocused(false)}
        >
            {searchTabs && Object.keys(searchTabs).length > 1 &&
                <Grow in={isFocused} unmountOnExit>
                    <div className='search-selector'>
                        {Object.entries(searchTabs).map(([key, value]) => {
                            return (
                                <button key={value + ' - ' + key} className={'search-type-button' + (activeSearch === key ? ' active' : '')} onClick={(e) => setFocus(e, key)}>
                                    {value}
                                </button>
                            )
                        })}
                    </div>
                </Grow>}
            <Autocomplete
                name='QuickFindCode'
                label={props.placeholder}
                styles={{ bgVariant: currentSite?.Site?.IsRVUniverse ? 'white' : null }}
                textFieldStyles={{willChange: 'transform', transform: 'translateZ(0)'} }
                showHistory
                openOnFocus
                searchType={activeSearch}
                partsUrl={props.partsUrl}
                attachmentsUrl={props.attachmentsUrl}
            />
        </div>
    );
};

export default QuickFind;
